<template>
  <transition name="fade">
    <div id="home">
      <Gate2026 />

      <main>
        <Header />
        <BannerMain />
        <Rules />
        <ShopsMap />
        <ContactUs />
        <Footer />
      </main>
    </div>
  </transition>
</template>

<script>
import Gate2026 from '@/components_2026/Gate2026.vue'
import Header from '@/components_2026/common/Header.vue'
import BannerMain from '@/components_2026/components/BannerMain.vue'
import Rules from '@/components_2026/components/Rules.vue'
import ShopsMap from '@/components_2026/components/ShopsMap.vue'
import ContactUs from '@/components_2026/common/ContactUs.vue'
import Footer from '@/components_2026/common/Footer.vue'

export default {
  name: 'Home2026',
  components: {
    Gate2026,
    Header,
    BannerMain,
    Rules,
    ShopsMap,
    ContactUs,
    Footer
  }
}
</script>
